(function () {
  class FAQAccordion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.querySelectorAll('.faq-question').forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.faq-item');
          item.classList.toggle('active');
        });
      });
    }
  }

  customElements.define('faq-accordion', FAQAccordion);
})();
